export default "__VITE_ASSET__DWhdn3uh__"